import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyRevisionsAddComponent } from '../../../property/property-revisions/property-revisions-add/property-revisions-add.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SharedPipesModule } from '../../shared-pipes/shared-pipes.module';
import { DataTablesModule } from 'angular-datatables';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxCurrencyDirective } from 'ngx-currency';
// import { NgxMaskModule } from 'ngx-mask';
// import { NgxCurrencyModule } from "ngx-currency";

@NgModule({
  declarations: [PropertyRevisionsAddComponent],
  exports: [PropertyRevisionsAddComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    //Ng2CompleterModule,
    SharedModule,
    BsDatepickerModule.forRoot(),
    // NgxMaskModule.forRoot(),
    SharedPipesModule,
    TooltipModule,
    DataTablesModule,
    RouterModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxCurrencyDirective
    // NgxCurrencyModule
  ],
})
export class SharedPropertyRevisionModule {}
